import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import {store} from './store'
import { getAuth, onAuthStateChanged } from "firebase/auth";

//app components
import alart from './components/shared/Alert.vue'
import appLoading from './components/shared/loading.vue'
import locationPicker from './components/shared/locationPicker'
import locationsAutocomplete from './components/shared/locationAutoComplete'
import imageComponent from './components/shared/imageUploader'
import ImageUploader from 'vue-image-upload-resize'
import dialPad from "./components/communication/dialPad";
import contactsPicker from './components/contacts/contactPicker'
import segmentPicker from './components/communication/segmentPicker'
import VueGeolocation from 'vue-browser-geolocation'
import emailSender from './components/communication/emailSender'
import billingDetails from "./components/billingAndUsage/billingDetails";

// third party components
import axios from 'axios'
import VueAxios from 'vue-axios'
import "./plugins/vuetify-mask.js";
import genericImageUploader from "@/components/shared/genericImageUploader";
import vueCountryRegionSelect from 'vue-country-region-select'
import CountryFlag from 'vue-country-flag'

//orders
import createOrder from './components/orders/createOrder'
import itemPicker from './components/orders/itemPicker'
import orderApp from './components/orders/order'
import datePicker from "./components/shared/dateTimePicker";
import paymentMethodPicker from "@/components/orders/paymentMethodPicker";
import dispatch from '@/components/orders/dispatch'
import fulfillment from "@/components/orders/fulfillment";
import addOnItemPicker from "@/components/shared/addOnItemPicker";
import serviceProviderRoles from "@/components/orders/serviceProviderRoles";
import multiClockTracker from "@/components/orders/multiClockTracker.vue";

// dashboard
import calender from "@/components/dashboard/calendar"
import phoneNumbersList from "@/components/dashboard/phoneNumbersList";
import transactionsGraph from "@/components/dashboard/transactionsGraph";
// dashboard
Vue.component('calender-app', calender)
Vue.component('phone-numbers-list', phoneNumbersList)
Vue.component('transactions-graph', transactionsGraph)
// orders
Vue.component('create-order', createOrder)
Vue.component('payment-method-picker', paymentMethodPicker)
Vue.component('dispatch-app', dispatch)
Vue.component('fulfillment-app', fulfillment)
Vue.component('service-roles', serviceProviderRoles)
Vue.component('multi-clock-tracker', multiClockTracker)
//bookings
Vue.component('order-app', orderApp)
// shared components
Vue.component('date-time-picker', datePicker)
Vue.component('contact-picker', contactsPicker)
Vue.component('segment-picker', segmentPicker)
Vue.component('addon-item-picker', addOnItemPicker)
Vue.component('app-alert', alart)
Vue.component('app-loading', appLoading)
Vue.component('get-location-app', locationPicker)
Vue.component('locations-autocomplete', locationsAutocomplete)
Vue.component('img-uploader', imageComponent)
Vue.component('gen-img-uploader', genericImageUploader)
Vue.component('find-item', itemPicker)
Vue.use(ImageUploader);
Vue.component('dial-pad', dialPad)
Vue.component('email-template-sender', emailSender)
Vue.component('user-billing-address', billingDetails)

// third party comps
Vue.use(VueAxios, axios)
Vue.use(VueGeolocation)
Vue.use(vueCountryRegionSelect)
Vue.component('country-flag', CountryFlag)

const auth = getAuth()

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
  created () {
    onAuthStateChanged(auth, (user) => {
        if (user) {
          // console.log(user)
          this.$store.dispatch('fetchUserData', user)
        }
      })
    }

}).$mount('#app')
